export default defineNuxtRouteMiddleware((to) => {
  const { token } = useAuth();

  // 1. requiresAuth && no token → redirect to login
  if (to.meta.requiresAuth && !token.value) {
    return navigateTo('/login');
  }
});
